import { useNow } from "@/hooks/useNow";
import { ORG_ACTIONS_READY } from "@/api/queries/orgActionsReady";
import { useQuery } from "@apollo/client";
import { useOrg } from "@/hooks/useOrg";
import { getDateString } from "@/util/dateUtils";

export const useGetActionsReady = () => {
  const { org, loading: orgLoading } = useOrg();
  const now = useNow();
  const todaysDate = new Date(now);

  const { data, loading, error } = useQuery(ORG_ACTIONS_READY, {
    variables: {
      orgId: org?.id || "",
      date: getDateString(todaysDate),
    },
    skip: !org?.id,
  });

  let ready = false;
  if (data?.node?.__typename === "Organization") {
    ready = !!data?.node.rise?.isActionGenerationComplete;
  }
  return { ready, loading: loading || orgLoading, error };
};
